<template>
  <div class="logo">
    <span class="logo-container">
      <img v-bind:src="require('@/assets/logo.png')" />
    </span>
  </div>
</template>

<script>
export default {
  name: "logo-view",
  props: {
    title: String,
  },
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.logo {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.logo-container {
  height: 70%;
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

img {
  height: 100%;
}

</style>
